import TurndownService from 'turndown';

const turndown = new TurndownService({
  headingStyle: 'atx',
  codeBlockStyle: 'fenced',
  bulletListMarker: '-',
});

// Keep code blocks with language
turndown.addRule('codeBlock', {
  filter: (node) => node.nodeName === 'PRE' && !!node.querySelector('code'),
  replacement: (_content, node) => {
    const code = (node as HTMLElement).querySelector('code');
    const lang = code?.getAttribute('class')?.replace('language-', '') ?? '';
    const text = code?.textContent ?? '';
    return `\n\`\`\`${lang}\n${text}\n\`\`\`\n`;
  },
});

/**
 * Convert HTML string (from TipTap editor) to Markdown.
 */
export function htmlToMarkdown(html: string): string {
  return turndown.turndown(html);
}
